import API_BASE_URL from '../config/apiConfig';
import createApiClient from '../config/apiClient';

const apiClient = createApiClient(API_BASE_URL);

export const trackPageView = (path: string) => {
  const url = `${API_BASE_URL}/page-view/track`;
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ path: path || '/' }),
    keepalive: true,
  }).catch(() => {});
};

export const getMonthlyStats = async (year: number, month: number) => {
  const res = await apiClient.get('/page-view/stats/monthly', { params: { year, month } });
  return res.data?.data ?? { total: 0, byPath: [] };
};

export const getMonthlyTrend = async (year?: number) => {
  const res = await apiClient.get('/page-view/stats/trend', { params: { year: year || new Date().getFullYear() } });
  return res.data?.data ?? [];
};

export const getDailyStats = async (year: number, month: number) => {
  const res = await apiClient.get('/page-view/stats/daily', { params: { year, month } });
  return res.data?.data ?? [];
};

export const getDailyStatsByRange = async (from: string, to: string) => {
  const res = await apiClient.get('/page-view/stats/daily', { params: { from, to } });
  return res.data?.data ?? [];
};
